module.exports = __webpack_public_path__ + "static/media/logo.694a8941.png";